import { defineCustomElement } from 'vue';
import InputFile from '../../../src/shared/InputFile.vue';

const InputFileElement = defineCustomElement(InputFile, { shadowRoot: false });
customElements.define('input-file', InputFileElement);
